import { Instance, SnapshotIn, types } from 'mobx-state-tree';
import { Currency, CurrencyProps } from 'models/reusable-parts/currency';

export interface FinancialMarkersRowProps {
  id: number;
  name: string;
  incidents: number;
  percentage: number;
  value: CurrencyProps;
}

export const FinancialMarkersRow = types.model({
  id: types.number,
  name: types.string,
  incidents: types.number,
  percentage: types.number,
  value: Currency,
});

export type FinancialMarkersRowSnapshot = SnapshotIn<
  typeof FinancialMarkersRow
>;
export type FinancialMarkersRowInstance = Instance<typeof FinancialMarkersRow>;
